import * as React from 'react';
import Styled from 'styled-components';

import { colorBlackberry45 } from '../../../lib/StyledComponents/Theme/amountCommon';
import { Toggle } from '../../Toggle';

const ToggleDarkMode = Styled(Toggle)`
  label {
    color: ${colorBlackberry45};

    &::before {
      border-color: ${colorBlackberry45};
    }
  }

  &:hover label,
  & > input:checked ~ label {
    color: ${({ theme: { colorWhite } }) => colorWhite};

    &::before {
      border-color: ${({theme: { colorWhite }}) => colorWhite};
    }
  }
`;

export interface IMenuToggleProps  {
  defaultChecked?: boolean;
  onClick (event: React.MouseEvent<HTMLInputElement, MouseEvent>): void;
}

const MenuToggle: React.FC<IMenuToggleProps> = ({ onClick, defaultChecked }) => (
  <ToggleDarkMode
    onClick={onClick}
    defaultChecked={defaultChecked}
  >
    Dark Mode
  </ToggleDarkMode>
);

export default MenuToggle;
